import React from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { ThemeProvider } from '@/components/theme-provider'
import { AppShell } from './shell/AppShell'
import { DashboardPage } from './pages/DashboardPage'
import { ConsignmentsPage } from './pages/ConsignmentsPage'
import { ConsignmentDetailPage } from './pages/ConsignmentDetailPage'
import { CustomerListPage } from './pages/CustomerListPage'
import { NewCustomerPage } from './pages/NewCustomerPage'
import { CustomerDetailPage, CustomerActivityPage, CustomerConsignmentsPage, CustomerInvoicesPage, CustomerOverviewPage } from './pages/CustomerDetailPage'
import { SettingsPage } from './pages/SettingsPage'
import { UsersPage } from './pages/UsersPage'
import { AcceptInvitationPage } from './pages/AcceptInvitationPage'
import { DocsPage } from './pages/DocsPage'
import { NotFoundPage } from './pages/NotFoundPage'
import { initHyperDXBrowserTelemetry, recordHyperDXPageView } from './lib/hyperdx-browser'
import NewConsignmentPage from '@/app/(dashboard)/consignments/new/page'
import '@/app/globals.css'

const router = createBrowserRouter([
  {
    path: '/',
    element: <AppShell />,
    errorElement: <NotFoundPage />,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'consignments', element: <ConsignmentsPage /> },
      { path: 'consignments/new', element: <NewConsignmentPage /> },
      { path: 'consignments/:id', element: <ConsignmentDetailPage /> },
      { path: 'consignments/:id/:tab', element: <ConsignmentDetailPage /> },
      { path: 'customers', element: <CustomerListPage /> },
      { path: 'customers/new', element: <NewCustomerPage /> },
      {
        path: 'customers/:id',
        element: <CustomerDetailPage />,
        children: [
          { index: true, element: <CustomerOverviewPage /> },
          { path: 'consignments', element: <CustomerConsignmentsPage /> },
          { path: 'invoices', element: <CustomerInvoicesPage /> },
          { path: 'activity', element: <CustomerActivityPage /> },
        ],
      },
      { path: 'settings', element: <SettingsPage /> },
      { path: 'settings/users', element: <UsersPage /> },
      { path: 'settings/users/accept', element: <AcceptInvitationPage /> },
      { path: 'docs', element: <DocsPage /> },
      { path: 'docs/*', element: <DocsPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
])

initHyperDXBrowserTelemetry()
recordHyperDXPageView(`${window.location.pathname}${window.location.search}`)
router.subscribe((state) => {
  recordHyperDXPageView(`${state.location.pathname}${state.location.search}`)
})

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange>
      <RouterProvider router={router} />
    </ThemeProvider>
  </React.StrictMode>,
)
